/**
 * Badge - saved markup.
 *
 * @package BrandyBlocks
 */

import { useBlockProps, RichText } from '@wordpress/block-editor';

import { getIconClasses } from '../../utils/helpers';
import { badgeStyle, iconStyle } from './badge-parts';

/**
 * @param {Object} props            Block props.
 * @param {Object} props.attributes Block attributes.
 * @return {JSX.Element} Saved markup.
 */
export default function Save( { attributes } ) {
	const { text, iconName, iconType, iconPosition, iconSize, style } = attributes;

	const blockProps = useBlockProps.save( { style: badgeStyle( style ) } );

	const iconClasses = getIconClasses( iconName, iconType );

	// aria-hidden because the label beside it already says what the badge says;
	// announcing the glyph would only repeat it as a name the author never wrote.
	const icon = iconClasses ? (
		<i className={ iconClasses } style={ iconStyle( iconSize ) } aria-hidden="true" />
	) : null;

	return (
		<div { ...blockProps }>
			{ iconPosition !== 'right' && icon }
			<RichText.Content tagName="span" className="brandy-badge__text" value={ text } />
			{ iconPosition === 'right' && icon }
		</div>
	);
}
